<template>
  <div>
    <p v-for="service in services" :key="service.title" :class="{'has-text-success': service.state == 'running', 'has-text-danger': service.state == 'stopped'}">
      {{service.title}}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      services: []
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  methods: {
    startMonitor() {
      this.$http
        .get(
          this.serverUrl +
            "services.php?services=smbd;lighttpd;transmission-daemon;minidlna;rsync;docker"
        )
        .then(response => {
          this.services = response.data;

          setTimeout(() => {
            this.startMonitor();
          }, 61000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// app/monitor/src/components/MonitorServices.vue